import { Navigate } from 'react-router-dom'
import { useAuthStore } from '../../store/authStore'

interface AppRouteProps {
  children: React.ReactNode
}

/** Allows authenticated users and guest browse mode. */
export default function AppRoute({ children }: AppRouteProps) {
  const hasAccess = useAuthStore(
    (s) => (s.isAuthenticated && !!s.accessToken) || s.isGuest,
  )
  if (!hasAccess) {
    return <Navigate to="/login" replace />
  }
  return <>{children}</>
}
